<template>
  <el-form
    v-loading.fullscreen.lock="fullscreenLoading"
    ref="FormGoals"
    :rules="rules"
    :model="model"
    label-position="top"
    class="padding-20"
    @submit.native.prevent="onSubmit">
    <el-row>
      <el-col :span="24">
        <el-form-item
          :label="propLabelModel"
          prop="$defaultId">
          <el-select
            v-model="model.$defaultId"
            :disabled="edit"
            filterable
            style="width: 100%"
            class="el-select"
            placeholder="Seleccione una opción">
            <el-option
              v-for="(item, index) in parseItems"
              :key="index"
              :label="item.label"
              :value="item.id"/>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="10">
        <el-form-item
          label="Año"
          prop="year">
          <el-select
            v-model="model.year"
            :disabled="edit"
            style="width: 100%"
            placeholder="Seleccione el año">
            <el-option
              v-for="(year, index) in years"
              :key="index"
              :label="year.label"
              :value="year.value"/>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="14">
        <el-form-item
          prop="type"
          label="Tipo">
          <el-select
            v-model="model.type"
            style="width: 100%"
            placeholder="Selecciona un tipo">
            <el-option
              label="Venta Tractores"
              value="Tractor"/>
            <el-option
              label="Venta Forrajero & E.E."
              value="Equipo Forrajero"/>
            <el-option
              label="Venta Implementos"
              value="Implemento"/>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <table v-if="model.type">
          <thead>
            <tr class="sales-table-header">
              <th>Mes</th>
              <th>Objetivo</th>
            </tr>
          </thead>
          <tbody v-if="model.type==='Tractor'">
            <tr
              v-for="($month, index) in model.$tractorMonths"
              :key="'tractor' + index"
            >
              <td class="month-cell">  {{ $month.label }}</td>
              <td>
                <el-form-item
                  :prop="`$tractorMonths.${index}.sales`">
                  <el-input-number
                    :min="0"
                    v-model="$month.sales"
                    class="sales-input"/>
                </el-form-item>
              </td>
            </tr>
          </tbody>
          <tbody v-else-if="model.type==='Equipo Forrajero'">
            <tr
              v-for="($month, index) in model.$forrajeroMonths"
              :key="'forrajero' + index"
            >
              <td class="month-cell">  {{ $month.label }}</td>
              <td>
                <el-form-item
                  :prop="`$forrajeroMonths.${index}.sales`">
                  <el-input-number
                    :min="0"
                    v-model="$month.sales"
                    class="sales-input"/>
                </el-form-item>
              </td>
            </tr>
          </tbody>
          <tbody v-else-if="model.type==='Implemento'">
            <tr
              v-for="($month, index) in model.$implementoMonths"
              :key="'implemento' + index"
            >
              <td class="month-cell">  {{ $month.label }}</td>
              <td>
                <el-form-item
                  :prop="`$implementoMonths.${index}.sales`">
                  <el-input-number
                    :min="0"
                    v-model="$month.sales"
                    class="sales-input"/>
                </el-form-item>
              </td>
            </tr>
          </tbody>
        </table>
      </el-col>

    </el-row>
    <el-row>
      <el-col :span="24">
        <el-button
          native-type="submit"
          type="primary">Guardar</el-button>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import GoalsModel from '@/models/goals/goals.model'
import {mapActions} from 'vuex'
import moment from 'moment'
export default {
  name: 'GoalsForm',
  props: {
    item: {
      type: Object,
      default: null
    },
    itemType: {
      type: String,
      default: 'dealer' // dealer, branch, seller
    },
    items: {
      type: Array,
      default () {
        return []
      }
    },
    goals: {
      type: Array,
      default: null
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      fullscreenLoading: false,
      model: this.edit ? GoalsModel.model(this.item, this.goals, this.$route.query.year || moment().format('YYYY')) : GoalsModel.model(),
      rules: GoalsModel.rules(),
      years: [
        {
          label: '2019',
          value: 2019
        },
        {
          label: '2018',
          value: 2018
        },
        {
          label: '2017',
          value: 2017
        }
      ]
    }
  },
  computed: {
    parseItems () {
      return this.items.map(item => {
        switch (this.itemType) {
          case 'dealer':
            return {...item, label: item.name}
          case 'branch':
            return {...item, label: item.city}
          case 'seller':
            return {...item, label: `${item.firstName} ${item.lastName}`}
        }
      })
    },
    propLabelModel () {
      switch (this.itemType) {
        case 'dealer':
          return 'Distribuidor'
        case 'branch':
          return 'Sucursal'
        case 'seller':
          return 'Vendedor'
      }
    }
  },
  watch: {
    item () {
      this.model = this.edit ? GoalsModel.model(this.item, this.goals, this.$route.query.year || moment().format('YYYY')) : GoalsModel.model()
    },
    goals () {
      this.model = this.edit ? GoalsModel.model(this.item, this.goals, this.$route.query.year || moment().format('YYYY')) : GoalsModel.model()
    }
  },
  methods: {
    ...mapActions('dealerGoals', ['save']),
    ...mapActions('branchGoals', {'saveBranch': 'save'}),
    ...mapActions('sellerGoals', {'saveSeller': 'save'}),
    saveDealer (model) {
      let _promises = []
      model.$tractorMonths.forEach($month => {
        let _model = {
          ...model,
          ...$month,
          dealerId: model.$defaultId,
          type: 'Tractor',
          month: $month.value,
          sales: $month.sales
        }
        _promises.push(this.save(_model))
      })
      model.$forrajeroMonths.forEach($month => {
        let _model = {
          ...model,
          ...$month,
          dealerId: model.$defaultId,
          type: 'Equipo Forrajero',
          month: $month.value,
          sales: $month.sales
        }
        _promises.push(this.save(_model))
      })
      model.$implementoMonths.forEach($month => {
        let _model = {
          ...model,
          ...$month,
          dealerId: model.$defaultId,
          type: 'Implemento',
          month: $month.value,
          sales: $month.sales
        }
        _promises.push(this.save(_model))
      })
      return _promises
    },
    branchSave (model) {
      let _promises = []
      model.$tractorMonths.forEach($month => {
        let _model = {
          ...model,
          ...$month,
          branchId: model.$defaultId,
          type: 'Tractor',
          month: $month.value,
          sales: $month.sales
        }
        _promises.push(this.saveBranch(_model))
      })
      model.$forrajeroMonths.forEach($month => {
        let _model = {
          ...model,
          ...$month,
          branchId: model.$defaultId,
          type: 'Equipo Forrajero',
          month: $month.value,
          sales: $month.sales
        }
        _promises.push(this.saveBranch(_model))
      })
      model.$implementoMonths.forEach($month => {
        let _model = {
          ...model,
          ...$month,
          branchId: model.$defaultId,
          type: 'Implemento',
          month: $month.value,
          sales: $month.sales
        }
        _promises.push(this.saveBranch(_model))
      })
      return _promises
    },
    sellerSave (model) {
      let _promises = []
      model.$tractorMonths.forEach($month => {
        let _model = {
          ...model,
          ...$month,
          userId: model.$defaultId,
          type: 'Tractor',
          month: $month.value,
          sales: $month.sales
        }
        _promises.push(this.saveSeller(_model))
      })
      model.$forrajeroMonths.forEach($month => {
        let _model = {
          ...model,
          ...$month,
          userId: model.$defaultId,
          type: 'Equipo Forrajero',
          month: $month.value,
          sales: $month.sales
        }
        _promises.push(this.saveSeller(_model))
      })
      model.$implementoMonths.forEach($month => {
        let _model = {
          ...model,
          ...$month,
          userId: model.$defaultId,
          type: 'Implemento',
          month: $month.value,
          sales: $month.sales
        }
        _promises.push(this.saveSeller(_model))
      })
      return _promises
    },
    onSubmit () {
      this.$refs['FormGoals'].validate((valid) => {
        if (valid) {
          let promises = null
          this.fullscreenLoading = true

          switch (this.itemType) {
            case 'dealer':
              promises = this.saveDealer(this.model)
              break
            case 'branch':
              promises = this.branchSave(this.model)
              break
            case 'seller':
              promises = this.sellerSave(this.model)
              break
          }
          return Promise.all(promises).then(response => {
            this.$message.success('El Objetivo se agregó con éxito')
            this.fullscreenLoading = false
            this.$store.dispatch('app/tooglesGoalsPanel')
            this.$emit('onCreate')
            return response
          })
            .catch(error => {
              this.fullscreenLoading = false
              this.$notify.error({
                group: 'app',
                title: 'Error al crear los objetivo.',
                message: 'Por favor, vuelve a intentarlo.'
              })
              return Promise.reject(error)
            })
        } else {
          this.$notify.error({
            group: 'app',
            title: 'Verifica el formulario.',
            message: 'Por favor, revisa los errores que se indican dentro del formulario.'
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
  table{
    table-layout: fixed;
    th{
      width: 50%;
    }
    td{
       .el-form-item{
         margin-bottom: 0px;
      }
    }
  }
  .sales-input{
    width: 100%;
  }
  .sales-table-header{
    background: $--color-primary;
    color: white;
    font-size: 14px;
    font-weight: 600;
    line-height: 40px;
  }
  .month-cell{
    font-size: 14px;
    padding-left: 12px;
  }

.el-button {
  background-color: $primary;
  color: #ffffff;
  width: 100%;
  box-shadow: 0 3px 6px 0 rgba(231, 18, 14, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/modules/goals/goals-form.vue